// Filter keys `/account/query/` no longer accepts. `cash_raise_status`
// filtered `Account.cash_raise_status`, which holds the raw request lifecycle
// (`REQUESTED`, `COMPLETED`, `CANCELED`, `REVERTED`) and was compared with a
// case-sensitive `hasAny` against the lowercase *display* statuses this app
// sent, so it never matched an account. Saved quick filters are persisted
// server-side as the whole filter blob, so old ones still carry the key and
// would fail input validation once the field is removed from the schema.
const RETIRED_ACCOUNT_FILTER_KEYS: ReadonlySet<string> = new Set([
  'cash_raise_status',
])

function withoutRetiredKeys(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(withoutRetiredKeys)
  if (value === null || typeof value !== 'object') return value

  const kept: Record<string, unknown> = {}
  for (const [key, nested] of Object.entries(value)) {
    if (RETIRED_ACCOUNT_FILTER_KEYS.has(key)) continue
    kept[key] = withoutRetiredKeys(nested)
  }
  return kept
}

/**
 * Drops retired keys from a decoded account-list filter, at every depth so
 * `or` / `and` / `not` branches are covered. Generic because the same decoded
 * payload is typed as `FilterObject` in the reducer and `AccountFilters` at the
 * query boundary; retired keys belong to neither, so the shape is unchanged.
 */
export function stripRetiredAccountFilterKeys<T>(filter: T): T {
  return withoutRetiredKeys(filter) as T
}
